import { render, staticRenderFns } from "./companyinfo.vue?vue&type=template&id=0c09f077&scoped=true"
import script from "./companyinfo.vue?vue&type=script&lang=js"
export * from "./companyinfo.vue?vue&type=script&lang=js"
import style0 from "./companyinfo.vue?vue&type=style&index=0&id=0c09f077&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09f077",
  null
  
)

export default component.exports